import getThemeFromProps from './getThemeFromProps';

const getInteractionsBasedOnProps = (props: any) => {
  const theme = getThemeFromProps(props);

  return theme.interactions;
};

export default getInteractionsBasedOnProps;
